module.exports = __webpack_public_path__ + "img/icon.4f15863e.png";